// extracted by mini-css-extract-plugin
export default {"setup-ipa-stores-and-clusters__callout":"SetupIpaStoresAndClusters_setup-ipa-stores-and-clusters__callout__ePU2w"};